<div class="create-ticket">
  <app-card [titleKey]="pageTitleKey" [cardModifier]="'card--profile-ticket'">
    <form [formGroup]="form" class="create-ticket__form">
      @if (isComplaintMode) {
        <div class="create-ticket__notice" role="status">
          <span
            class="fas fa-info-circle create-ticket__notice-icon"
            aria-hidden="true"
          ></span>
          <p class="create-ticket__notice-text">
            {{ "profile.createTicket.complaintInfo" | translate }}
          </p>
        </div>
        <hr class="create-ticket__divider" />
      }

      @if (isComplaintMode) {
        <div class="create-ticket__field">
          <app-validated-dropdown
            [label]="'profile.createTicket.complaintTopic'"
            inputFormControlName="complaintType"
            [inputFormControl]="form.controls.complaintType"
            [leaveSpaceForValidation]="true"
            [haveEmptyOption]="false"
            [disabled]="typesLoading()"
            [validationTrainslations]="{
              required: 'validation.required',
            }"
            (selectionChanged)="onComplaintTypeSelected()"
          >
            @for (t of complaintTypes(); track t.id) {
              <option [ngValue]="t.id">
                {{ complaintTypeLabelKey(t) | translate }}
              </option>
            }
          </app-validated-dropdown>
        </div>
      }

      <div class="create-ticket__field create-ticket__field--message">
        <app-validated-textarea
          [label]="messageFieldLabelKey()"
          [rows]="12"
          inputFormControlName="message"
          [inputFormControl]="form.controls.message"
          [maxLength]="maxMessageLength"
          [leaveSpaceForValidation]="true"
          [validationTrainslations]="{
            required: 'validation.required',
            maxlength: 'validation.maxLength',
          }"
        />
      </div>

      <hr class="create-ticket__divider" />

      <app-upload-files
        class="create-ticket__files"
        [formControls]="form.controls.files"
        [title]="'profile.createTicket.documents'"
        [canAdd]="true"
        (createNewFileGroup)="addFileRow()"
      />
    </form>
  </app-card>

  <div class="create-ticket__actions">
    <app-button
      [label]="'general.cancel' | translate"
      [btnClass]="'btn btn-falcon-default d-flex align-items-center gap-2'"
      (clicked)="cancel()"
    />
    <app-button
      [iconClass]="'fas fa-paper-plane'"
      [label]="'general.send' | translate"
      [btnClass]="'btn btn-primary d-flex align-items-center gap-2'"
      [disabled]="form.invalid || typesLoading()"
      [loading]="sending()"
      (clicked)="submit()"
    />
  </div>
</div>
